import styled from "styled-components";
export const StyledFooterRow = styled.tr `
  background: ${({ theme }) => `rgb(${theme.colors.transparentBlack}, 0.12)`};
  font-size: ${({ theme }) => theme.fontTokens.font12[0]};
  line-height: ${({ theme }) => theme.fontTokens.font12[1]};
  font-weight: ${({ theme }) => theme.fontWeights.bold};

  td {
    padding: 0 1rem;
    :last-child {
      padding-right: 1rem;
    }
  }
`;
